import * as React from "react";
import { SVGProps } from "react";

const Wing = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 437 298" {...props}>
    <path d="m286.3 100.1-38.1 66-38.1 66-38 65.9-38.1-65.9 38.1-66 38.1-65.9L152.4 0h76.1l19.8 34.2 38 65.9zM76.2 0H0l95.9 166.1 38.1-65.9L76.2 0zm323.5 34.2L379.9 0h-76.1l57.8 100.1-38.1 66-38.1 66 38.1 65.9 38.1-65.9 38.1-66 38.1-65.9-38.1-66z" />
  </svg>
);

export default Wing;
